/* prettier-ignore */

import { Component, AfterViewInit } from '@angular/core';
import { GoogleTranslateService } from 'src/app/services/google-translate.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'google-translate',
  templateUrl: './google-translate.component.html',
  styleUrls: ['./google-translate.component.css']
})
export class GoogleTranslateComponent implements AfterViewInit {

  public ISOCodesArray: any = [];

  constructor(public googleTranslateService: GoogleTranslateService, private rest: RestService){
    this.ISOCodesArray = this.googleTranslateService.availableLangs.map(lang => lang.code)?.join(',');
  }

  ngAfterViewInit() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    document.body.appendChild(script);

    (window as any).googleTranslateElementInit = () => {
      new (window as any).google.translate.TranslateElement(
        {
          pageLanguage: this.rest.device?.mainLanguage || 'es',
          includedLanguages: this.ISOCodesArray,
          autoDisplay: false,
          layout: (window as any).google.translate.TranslateElement.InlineLayout.SIMPLE
        },
        'google_translate_element'
      );
    };
  }

  preventReload(e: any){
    e.preventDefault();
  }
}